import clsx from 'clsx';
import { MenuItem } from './MenuItem';
import { Popper } from '../Popper';
import { ReactNode } from 'react';
import { Backdrop } from '../Backdrop/Backdrop';
import { Placement } from '@popperjs/core';

interface Props extends BaseProps {
  anchorEl: Element | null;
  children: ReactNode;
  className?: string;
  onClose(): void;
  offsetX?: number;
  offsetY?: number;
  placement?: Placement;
  showArrow?: boolean;
  theme?: 'default' | 'dark';
}

const Menu = ({
  anchorEl,
  children,
  className,
  onClose,
  offsetX,
  offsetY,
  placement = 'bottom',
  showArrow = false,
  theme = 'default',
  ...rest
}: Props) => {
  const classes = useStyles();
  return (
    <Backdrop open={Boolean(anchorEl)} onClose={onClose} disableBlur>
      <Popper
        className={clsx('!bg-transparent', classes.arrow[theme])}
        anchorEl={anchorEl}
        isVisible={Boolean(anchorEl)}
        offsetX={offsetX}
        offsetY={offsetY}
        placement={placement}
        showArrow={showArrow}
      >
        <ul
          role="menu"
          className={clsx(className, 'py-2 rounded', classes.theme[theme])}
          {...rest}
        >
          {children}
        </ul>
      </Popper>
    </Backdrop>
  );
};

const useStyles = () => ({
  arrow: {
    default: 'children:before:!bg-background-dark',
    dark: 'children:before:!bg-black',
  },
  theme: {
    default: '!bg-background-dark',
    dark: '!bg-black',
  },
});

export { Menu, MenuItem };
